import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    clientname: {
      validations: []
    },
    telnumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
        { type: 'required', message: 'Please provide a phone number' }
      ]
    },
    theme: {
      validations: []
    },
    operation: {
      validations: [
        { type: 'required', message: 'Please select a service type' },
      ]
    },
    SiteName: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' },
        { type: 'required', message: 'Please provide an event date' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please enter the number of guests' }
      ]
    },
    reference: {
      validations: []
    },
    notes: {
      validations: [
        { type: 'required', message: 'Please enter information' }
      ]
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:*',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
         ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Company (If Applicable):',
              mapping: 'clientname'
            },
           ]
          },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone:*',
           mapping: 'telnumber'
         }
       ]
     },
     {
      fields: [
        {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Event Type:',
          options: [
            { label: 'Wedding'  , value: 'Wedding'},
            { label: 'Private/Social'  , value: 'Private/Social'},
            { label: 'Corporate'  , value: 'Corporate'},
            { label: 'Non-Profit'  , value: 'Non-Profit'},
          ],  
          mapping: 'theme'
        }
      ]
    },
    {
      fields: [
        {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Service Type:*',
          options: [
            {label: 'Plated' , value: 'Plated'},
            {label: 'Buffet' , value: 'Buffet'},
            {label: 'Stations' , value: 'Stations'},
          ],
          mapping: 'operation'
        }
      ]
    },
    {
      fields: [
        {
          type: 'date-picker',
          size: 'Medium',
          label: 'Event Date:*',
          mapping: 'eventDate'
        }
      ]
    },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Guest Count:*',
                mapping: 'plannedguestcount'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Venue:',
                options: [
                  {label: 'The Hillside Estate' , value: 'The Hillside Estate'},
                ],
                mapping: 'reference'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'Medium',
                label: 'Tell us a little bit about your Event:*',
                mapping: 'notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SEND FORM'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Blue Fire Total Catering Contact Form',
    formId: '2173',
    clientKey: '96F511AD-FC24-40CC-BF72-C5E12B86C35D',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
